var map = {
	"./dfk-lubowice-35-anniversary.jpg": "5ba6",
	"./haus-salia.jpg": "7093",
	"./spectrum-article.jpg": "b2a9",
	"./wochenblatt-33-jahre.jpg": "6bc6",
	"./wochenblatt-article.jpg": "9cf8",
	"./wochenblatt-freies-denken.jpg": "626f",
	"./wochenblatt-pilgrim.jpg": "8222",
	"./wochenblatt-rheno-palatia.jpg": "1330",
	"./wochenblatt-schlesien-herzen.jpg": "4f3e",
	"./zimmer-frei.jpg": "c7c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "03c1";